import clsx from "clsx";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getBookingPayment,
  getBookingStatus,
  updatePayment,
  updatePaymentReceipt,
  uploadFile,
} from "../../../redux/adminActionCreator";
import { booking_payment_details } from "../../../redux/adminReducer";
import { API_BASE_URL, IMAGE_BASE_URL } from "../../../constants/configuration";
import moment from "moment";
import FileUpload from "../../../commonComponents/FileUpload/FileUpload";
import { loadStripe } from "@stripe/stripe-js";
import {
  errorToast,
  getBookingDetails,
  retrievePaymentSession,
} from "../../../redux/commonActionCreator";
import PaymentSuccess from "./PaymentSuccess";
import { Spinner } from "react-bootstrap";

export default function Timeline() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const sessionId = urlParams.get("session_id");
  const status = urlParams.get("status");

  const stripePromise = loadStripe(
    "pk_live_51QAqgSK1W1Q4AF20JX94hhdxkLtUxiTZz2lFOmXQO9Ik5I7cLSi2UlyB4WbWxluFyMuyI3i5PmkNeFzWiHPcdIdb008Ls99V1T"
  );

  const bookingId = localStorage.getItem("booking_id");
  const bookingDetails = JSON.parse(localStorage.getItem("booking_details"));

  const details = useSelector(booking_payment_details);
  const [loadingStates, setLoadingStates] = useState({});
  const [mileStoneData, setMileStoneData] = useState([]);
  const [err, setErr] = useState({});
  const [invalidUpload, setInvalidUpload] = useState(false);
  const [trackId, setTrackId] = useState("");
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentValues, setPaymentValues] = useState("");

  const paymentStatusList = [
    { label: "Payment Initiated", value: "init" },
    { label: "Payment Pending", value: "pending" },
    { label: "Payment Captured", value: "captured" },
    { label: "Payment Failed", value: "failed" },
    { label: "Payment Refunded", value: "refunded" },
  ];

  useEffect(() => {
    if (bookingId) {
      dispatch(getBookingPayment(bookingId));
    }
  }, [bookingId]);

  useEffect(() => {
    if (details?.bookingpayment?.milestone?.length) {
      let temp = [];
      details?.bookingpayment?.milestone?.forEach((ele, index) => {
        temp.push({
          ...ele,
          payment_status:
            paymentStatusList?.filter(
              (el) => el?.value == ele?.payment_status
            )?.[0] ?? "",
          website_receipt:
            details?.customerengagements?.payment_method === "direct"
              ? ""
              : ele?.website_receipt
              ? [
                  {
                    type: ele?.website_receipt?.split(".").pop(),
                    url: `${IMAGE_BASE_URL}${"booking"}/${
                      ele?.website_receipt
                    }`,
                    name: `${ele?.website_receipt}`,
                    response: `${ele?.website_receipt}`,
                  },
                ]
              : "",
        });
      });
      setMileStoneData([...temp]);
    }
  }, [details]);

  useEffect(() => {
    if (status == "success") {
      sessionSubmit();
    } else if (status == "failed") {
      errorToast("Payment Failed");
    }
  }, [sessionId, status]);

  const singleFileUploadHandler = (
    e,
    isInvalid,
    message,
    isClosing,
    ele,
    index
  ) => {
    if (isInvalid) {
      setInvalidUpload(true);
      setErr({
        ...err,
        [`receipt_${index}`]: message,
      });
    } else {
      setInvalidUpload(false);
      setErr({
        ...err,
        [`receipt_${index}`]: "",
      });
      if (e?.some((elem, i) => elem?.metaFile) && !isClosing) {
        let formData = new FormData();
        let track_id;
        if (trackId?.length == 0) {
          track_id = Math.floor(1000 + Math.random() * 9000).toString();
          setTrackId(track_id);
          formData.append("track_id", track_id);
        } else {
          track_id = trackId;
          formData.append("track_id", trackId);
        }
        formData.append("file", e[0]?.metaFile);
        dispatch(
          uploadFile(formData, (res) => {
            let tempValue = [
              {
                type: e[0].type,
                url: e[0].url,
                name: e[0]?.name,
                metaFile: e,
                response: res?.data[0],
              },
            ];
            milestoneDataChangeHandler(tempValue, index);
            receiptSubmitHandler(ele, res?.data[0], track_id);
          })
        );
      }
    }
  };

  const milestoneDataChangeHandler = (value, index) => {
    let dataList = [...mileStoneData];
    dataList[index]["receipt"] = value;
    setMileStoneData(dataList);
  };

  const receiptSubmitHandler = (ele, receipt, track_id) => {
    let raw = {
      booking_id: bookingId,
      milestone_id: ele?._id,
      upload_receipt: receipt,
      track_id: track_id,
    };
    dispatch(
      updatePaymentReceipt(raw, () => {
        dispatch(getBookingPayment(bookingId));
      })
    );
  };

  const paymentHandler = (ele, index) => {
    handleCheckout(ele, index);
  };

  const handleCheckout = async (ele, index) => {
    try {
      setLoadingStates((prev) => ({ ...prev, [index]: true }));

      const stripe = await stripePromise;

      const response = await fetch(`${API_BASE_URL}createPaymentIntent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: ele?.value,
          currency: "usd",
          booking_id: bookingId,
          base_url: window.location.origin,
          package_id: ele?._id,
          package_name: `${bookingDetails?.booking_ref_id} of ${bookingDetails?.bookingitinerary?.package_name}(${ele?.milestone_name})`,
          email: bookingDetails?.traveller_info?.[0]?.email,
          first_name: bookingDetails?.traveller_info?.[0]?.first_name,
          type: "milestone",
        }),
      });

      const session = await response.json();

      const { error } = await stripe.redirectToCheckout({
        sessionId: session.session_id,
      });

      if (error) {
        console.error("Stripe Checkout Error:", error);
        localStorage.setItem("book_now_loader", false);
      }
    } catch (error) {
      console.error("Error during checkout:", error);
    } finally {
      setLoadingStates((prev) => ({ ...prev, [index]: false }));
    }
  };

  const sessionSubmit = () => {
    let raw = {
      session_id: sessionId,
    };
    dispatch(
      retrievePaymentSession(raw, (res) => {
        setPaymentValues(res);
        setPaymentModal(true);
        onPaymentSubmitHandler(res);
      })
    );
  };

  const onPaymentSubmitHandler = (payDetails) => {
    let raw = {
      payment_id: payDetails?.payment_id,
      payment_status: payDetails?.payment_status,
      paid_amount: payDetails?.amount_total,
      receipt_url: payDetails?.receipt_url,
      booking_id: payDetails?.metadata?.booking_id,
      milestone_id: payDetails?.metadata?.package_id,
    };
    console.log(raw, "raw");
    dispatch(
      updatePayment(raw, (res) => {
        if (res.status) {
          dispatch(getBookingPayment(bookingId));
          dispatch(getBookingStatus(bookingId));
          dispatch(getBookingDetails(bookingId));
          // setTimeout(() => {
          //   handleClose();
          //   navigate("/payment-section");
          //   dispatch(getBookingPayment(bookingId));
          // }, 2000);
        } else {
        }
      })
    );
  };

  const handleClose = () => {
    setPaymentValues("");
    setPaymentModal(false);
    dispatch(getBookingPayment(bookingId));
    dispatch(getBookingStatus(bookingId));
    dispatch(getBookingDetails(bookingId));
    navigate("/payment-section");
  };

  return (
    <section id="timeline" className=" position-relative">
      <div className="container position-relative px-4">
        <div className="Card Timeline position-relative">
          <div className="timeline-container">
            {mileStoneData.map((ele, index) => (
              <div className="row TimelineItem" key={ele._id}>
                <LeftBox
                  title={ele.milestone_name}
                  index={index + 1}
                  payment_status={ele?.payment_status}
                  details={details}
                />
                <RightBox
                  key={index}
                  details={details}
                  ele={ele}
                  err={err}
                  singleFileUploadHandler={singleFileUploadHandler}
                  index={index}
                  paymentHandler={paymentHandler}
                  isLoading={loadingStates[index]}
                />
              </div>
            ))}
            {details?.bookingpayment?.payment_mode === "onetime" ? (
              <></>
            ) : (
              <div className="Milestone">
                <svg
                  id="Group_41495"
                  data-name="Group 41495"
                  xmlns="http://www.w3.org/2000/svg"
                  width="46.743"
                  height="58.69"
                  viewBox="0 0 46.743 58.69"
                >
                  <defs>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_23205"
                        data-name="Rectangle 23205"
                        width="46.743"
                        height="58.69"
                        fill="#02529c"
                      />
                    </clipPath>
                  </defs>
                  <g
                    id="Group_41246"
                    data-name="Group 41246"
                    clip-path="url(#clip-path)"
                  >
                    <path
                      id="Path_78983"
                      data-name="Path 78983"
                      d="M3.207,50.474v-.7q0-9.878,0-19.755c0-1.083.272-1.349,1.375-1.353,2.509-.01,5.018-.016,7.527-.033.53,0,1.049-.009,1.307.573.275.621-.124,1.006-.517,1.379-.73.691-1.468,1.374-2.257,2.11.881.9,1.665,1.664,2.408,2.469a1.628,1.628,0,0,1,.435.859c.055.541-.415.9-1.077.906-2.193.006-4.386,0-6.579,0H5.147V50.507a4.274,4.274,0,0,1,3.047,3.06c.159.01.31.027.461.027q12.21,0,24.421,0a6.2,6.2,0,0,0,.3-12.4c-2.133-.043-4.268,0-6.4-.022-.344,0-.463.123-.576.427A4.139,4.139,0,0,1,21.98,44.34a4.2,4.2,0,0,1-3.633-3.858,1.2,1.2,0,0,0-.48-.711,7.887,7.887,0,0,1-3.455-7.524,7.789,7.789,0,0,1,4.967-6.673,6.479,6.479,0,0,1,1.644-.465c.446-.064.537-.239.535-.646-.015-2.9-.009-5.8-.007-8.695,0-1.168.254-1.416,1.43-1.42,2.509-.009,5.018-.015,7.527-.034.518,0,1.015.023,1.251.57.247.573-.075.977-.473,1.342-.755.693-1.508,1.389-2.319,2.137l1.981,2.012c.194.2.46.361.565.6a1.59,1.59,0,0,1,.21,1.062,1.211,1.211,0,0,1-.916.554c-1.8.053-3.6.026-5.393.026H23.489v2.313c.151.013.3.037.456.037,2.964,0,5.927,0,8.891.01a.581.581,0,0,0,.665-.47c.437-1.249,1.1-1.829,2.93-2.681v-.687q0-9.819,0-19.637c0-1.2.26-1.462,1.457-1.466C40.417.025,42.946.019,45.475,0c.5,0,.962.057,1.185.58a1.043,1.043,0,0,1-.4,1.252c-.784.721-1.564,1.446-2.4,2.219l2.064,2.087c.153.154.3.311.458.463a.962.962,0,0,1-.731,1.7c-2.193-.007-4.386,0-6.579,0h-.7V21.739a13.949,13.949,0,0,1,1.857,1.2,4.022,4.022,0,0,1,1.011,4.5,4.178,4.178,0,0,1-3.886,2.613,4.042,4.042,0,0,1-3.8-2.62.767.767,0,0,0-.893-.583c-2.825.019-5.651.009-8.476.009h-.7c-.015.219-.038.406-.038.593,0,2.721.006,5.442-.01,8.162a.666.666,0,0,0,.521.758,3.855,3.855,0,0,1,2.411,2.442c.138.4.341.479.724.476,2.015-.018,4.031-.016,6.046-.006A8.1,8.1,0,0,1,34.875,55.3a9.192,9.192,0,0,1-1.94.183q-12.092.018-24.184,0c-.373,0-.575.057-.724.472A4.118,4.118,0,0,1,3.7,58.663,4.187,4.187,0,0,1,.027,55.04a4.137,4.137,0,0,1,2.762-4.4c.129-.048.257-.1.418-.162M21.55,26.994c-2.287.059-4.562,2.158-5.137,4.65-.579,2.511.551,5.444,2.506,6.456a4.53,4.53,0,0,1,2.366-1.848c.135-.046.251-.361.253-.553.018-2.125.011-4.251.011-6.377,0-.765,0-1.531,0-2.327M38.361,6.366h5l.127-.166c-.452-.4-.923-.783-1.351-1.208-.6-.6-.587-1.059,0-1.669.429-.442.859-.883,1.33-1.367H38.361ZM10.269,30.751l-.142-.169H5.134V35h5l.091-.131c-.47-.439-.957-.862-1.407-1.321a.928.928,0,0,1,0-1.494c.458-.459.966-.868,1.452-1.3m13.217-10.07h4.992l.091-.13c-.443-.412-.9-.813-1.326-1.24-.611-.609-.6-1.043,0-1.671.428-.444.862-.881,1.349-1.378H23.486ZM22.5,42.474a2.246,2.246,0,1,0-2.252-2.249A2.233,2.233,0,0,0,22.5,42.474M39.628,25.907a2.238,2.238,0,0,0-2.263-2.239,2.246,2.246,0,0,0,.014,4.491,2.237,2.237,0,0,0,2.249-2.252M1.906,54.555a2.243,2.243,0,0,0,2.27,2.233A2.246,2.246,0,0,0,4.15,52.3a2.241,2.241,0,0,0-2.244,2.259"
                      transform="translate(0 0)"
                      fill="#02529c"
                    />
                  </g>
                </svg>
                {/* LOGO */} <h3 className="text-uppercase">Milestone</h3>
              </div>
            )}
          </div>
        </div>
        <div className="traveller_submit d-flex justify-content-end align-items-center mb-4 mt-3">
          <button
            style={{ textWrap: "nowrap", width: "auto" }}
            onClick={() => navigate("/payments")}
          >
            View Payment Home
          </button>
        </div>

        <div className="Card History">
          <div className="px-5">
            <h3 className="text-uppercase HistoryTitle">Payment History</h3>
          </div>
          <div className="px-5">
            <h4>
              {" "}
              Package Name : {bookingDetails?.bookingitinerary?.package_name}
            </h4>
          </div>
          <div className="table-responsive">
            <table className="table table-bordered">
              <tbody>
                {details?.bookingpayment?.payment_advance?.map((ele, i) => {
                  return (
                    <tr>
                      <td>{i + 1}</td>
                      <td>Token Advance Payment</td>
                      <td>Token Payment</td>
                      <td>{ele?.amount} USD</td>
                      <td>
                        <div className="Chip ChipSuccess">
                          {ele?.payment_status == "captured"
                            ? "Success"
                            : "Pending"}
                        </div>
                      </td>
                    </tr>
                  );
                })}
                {details?.bookingpayment?.milestone
                  ?.filter((item) => item?.payment_status == "captured")
                  ?.map((ele, i) => {
                    return (
                      <tr>
                        <td>
                          {details?.bookingpayment?.payment_advance?.length +
                            i +
                            1}
                        </td>
                        <td>
                          {details?.bookingpayment?.payment_mode === "onetime"
                            ? "Onetime Payment"
                            : `Milestone ${i + 1}`}
                        </td>
                        <td>{ele?.milestone_name}</td>
                        <td>{Math.trunc(Number(ele?.value))} USD</td>
                        <td>
                          <div
                            className={`Chip ${
                              ele?.payment_status == "captured"
                                ? "ChipSuccess"
                                : "ChipPending"
                            }`}
                          >
                            {ele?.payment_status == "captured"
                              ? "Success"
                              : "Pending"}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {paymentModal ? (
        <PaymentSuccess
          handleClose={handleClose}
          paymentModal={paymentModal}
          paymentValues={paymentValues}
        />
      ) : (
        <></>
      )}
    </section>
  );
}

function LeftBox({ title, index, payment_status, details }) {
  return (
    <div className="col-6 Box">
      <h1
        className={clsx(
          "Title text-end text-uppercase me-3",
          payment_status?.value != "captured" ? "TitlePrimary" : "TitleMuted"
        )}
      >
        {details?.bookingpayment?.payment_mode === "onetime" ? (
          <>Onetime</>
        ) : (
          <>Milestone {index}</>
        )}
      </h1>
      <p className="font-archivo-expanded text-muted text-end me-3 Desc">
        {title}
      </p>
    </div>
  );
}

function RightBox({
  ele,
  details,
  err,
  singleFileUploadHandler,
  index,
  paymentHandler,
  isLoading,
}) {
  return (
    <div className="col-6 border-top mt-2 Box">
      <div className="d-flex align-items-start gap-3 ms-3 pt-4">
        {ele?.payment_status?.value !== "captured" && ele?.date && (
          <div
            className={clsx(
              "Chip",
              ele?.payment_status?.value == "captured"
                ? "ChipPrimary"
                : "ChipSecondary"
            )}
          >
            {ele?.date
              ? `Due On ${moment(ele?.date).format("DD MMMM YYYY")}`
              : ""}
          </div>
        )}

        <div>
          <h1
            className={clsx(
              "Price d-flex align-items-center",
              ele?.payment_status?.value != "captured" ? "Active" : "Muted"
            )}
          >
            {Math.trunc(Number(ele?.value))}{" "}
            <span className={"Currency"}>USD</span>
          </h1>
          {ele?.payment_status?.value == "captured" ? (
            <div className="d-flex ">
              <span className="ItalicText">
                Paid On {`${moment(ele?.date).format("DD MMMM YYYY")}`}
              </span>
            </div>
          ) : (
            <>
              {details?.customerengagements?.payment_method === "direct" ? (
                <div className="item mt-4">
                  <FileUpload
                    style={{
                      marginRight: 5,
                      marginTop: 15,
                    }}
                    className="css-atc-esc1 mt-0 mb-0"
                    showPreview
                    label="Add Attachment"
                    buttonLabel="Choose File"
                    accept={["jpg", "jpeg", "png", "svg", "pdf"]}
                    onChange={(e, isInvalid, message, isClosing) => {
                      singleFileUploadHandler(
                        e,
                        isInvalid,
                        message,
                        isClosing,
                        ele,
                        index
                      );
                    }}
                    field={"attachment"}
                    // loader={imageLoader}
                    error={err.attachment}
                    id="attachment"
                    maxFileSizeMB={100}
                    files={ele?.attachment}
                    inputSocket={() => {}}
                  />
                </div>
              ) : (
                <button
                  type="button"
                  className="btn btn-success PayNowButton"
                  onClick={() => paymentHandler(ele, index)}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      Pay Now{" "}
                      <Spinner
                        animation="border"
                        size="sm"
                        style={{ marginLeft: "10px" }}
                      />
                    </>
                  ) : (
                    <>
                      <img
                        src="/assets/img/admin/pay-clock.svg"
                        style={{ height: "18px" }}
                        alt=""
                      />{" "}
                      Pay Now{" "}
                      <img src="/assets/img/admin/pay-arrow.svg" alt="" />
                    </>
                  )}
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function truncate(text) {
  return text.length > 156 ? text.slice(0, 156) + "..." : text;
}
